import { request, Paginated } from "utils/api";

export const customErrors = ["associationDomainIsTaken", "commonEmailDomain", "invalidEmailFormat"];

export type AssociationAction = "auto-add" | "none" | "request";

export interface DomainAssociations {
    id: string;
    createdAt: Date,
    updatedAt: Date,
    domain: string;
    verificationEmail: string;
    associationAction: AssociationAction,
    associationStatus: "pending" | "verified",
}

const domainAssociationUrl = "/admin/domain-associations";

export const getDomainAssociations = (data: {
    clubId: string,
    limit?: number,
    offset?: number,
}) => request<Paginated<DomainAssociations>>({
    data,
    endpoint: domainAssociationUrl,
    method: "get",
});

export const postDomainAssociations = (data: {
    clubId: string,
    verificationEmail: string,
}) => request<DomainAssociations>({
    data,
    endpoint: domainAssociationUrl,
    method: "post",
});

export const patchDomainAssociations = (data: {
    associationId: string,
    verificationCode?: string,
    resend?: boolean,
    associationAction?: AssociationAction,
}) => request<DomainAssociations>({
    data,
    endpoint: domainAssociationUrl,
    method: "patch",
});

export const deleteDomainAssociations = (data: {
    associationId: string,
}) => request<{}>({
    data,
    endpoint: domainAssociationUrl,
    method: "delete",
});
